import { useEffect } from 'react';
import { observable, reaction } from 'mobx';
import { noop } from '@src/utils/common-util';

class FooterStore {
  @observable isShowBackTop = false;
  @observable onBackTop = noop;

  constructor(options = {}) {
    const { onBackTop, ...rest } = options;
    this.onBackTop = onBackTop || noop;
    Object.assign(this, rest);
  }

  use() {
    useEffect(() => {
      window.init_OMNI__COMMON__FOOTER();
      window.OMNI__COMMON__FOOTER = {
        to_top_handler: this.onBackTop
      };
    }, []);

    useEffect(() => {
      reaction(
        () => this.isShowBackTop,
        isShow => {
          const backTopButton = document.querySelector('#common_to_top_btn');
          if (!backTopButton) {
            return;
          }
          if (isShow) {
            backTopButton.style.display = 'block';
          } else {
            backTopButton.style.display = 'none';
          }
        }
      );
    }, []);
  }
}

export default FooterStore;
